import Vue from 'vue'
import VueRouter from 'vue-router'
import store from './../store'
import { getToken, getUser } from '@/utils/auth'

// 重写路由的push方法，解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const routerPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (to) {
  return routerPush.call(this, to).catch(error => error)
}

Vue.use(VueRouter)

// 无需登录路由
const fixedRoutes = [
  {
    path: '/',
    redirect: '/index',
    hidden: true
  },
  {
    path: '/login',
    name: 'login',
    hidden: true,
    component: () => import('@/views/Login')
  },
  {
    path: '/notFound',
    name: 'notFound',
    hidden: true,
    component: () => import('@/views/NotFound')
  }
]
// 主页
const createIndexRoute = () => {
  return {
    path: '/index',
    name: 'index',
    hidden: true,
    component: () => import('@/views/Index'),
    redirect: '/home',
    children: [
      {
        id: '1',
        path: '/home',
        name: 'home',
        hidden: false,
        component: () => import('@/views/Home'),
        icon: 'el-icon-s-home',
        meta: {
          label: '首页'
        }
      }
    ]
  }
}
// 需要权限路由
// eslint-disable-next-line no-unused-vars
const createPermissionRoutes = () => {
  return [
    {
      id: '1',
      path: '/',
      name: 'userInfo',
      hidden: false,
      icon: 'el-icon-zdy-user',
      meta: {
        label: '用户管理',
        permissions: ['PM020101', 'PM020201', 'PM020301', 'PM020401', 'PM020501', 'PM020601', 'PM020701', 'PM020801']
      },
      children: [
        {
          id: '11',
          path: '/userInfoList3',
          name: 'userInfoList3',
          hidden: false,
          icon: '',
          component: () => import('@/views/userInfo/UserInfoList3'),
          meta: {
            label: '椒农用户',
            permissions: ['PM020101']
          }
        },
        {
          id: '12',
          path: '/userInfoList4',
          name: 'userInfoList4',
          hidden: false,
          icon: '',
          component: () => import('@/views/userInfo/UserInfoList4'),
          meta: {
            label: '技术专家',
            permissions: ['PM020201']
          }
        },
        {
          id: '13',
          path: '/userInfoList5',
          name: 'userInfoList5',
          hidden: false,
          icon: '',
          component: () => import('@/views/userInfo/UserInfoList5'),
          meta: {
            label: '合作社用户',
            permissions: ['PM020301']
          }
        },
        {
          id: '14',
          path: '/userInfoList6',
          name: 'userInfoList6',
          hidden: false,
          icon: '',
          component: () => import('@/views/userInfo/UserInfoList6'),
          meta: {
            label: '企业用户',
            permissions: ['PM020401']
          }
        },
        {
          id: '15',
          path: '/userInfoList7',
          name: 'userInfoList7',
          hidden: false,
          icon: '',
          component: () => import('@/views/userInfo/UserInfoList7'),
          meta: {
            label: '经销商用户',
            permissions: ['PM020501']
          }
        },
        {
          id: '18',
          path: '/userInfoList8',
          name: 'userInfoList8',
          hidden: false,
          icon: '',
          component: () => import('@/views/userInfo/UserInfoList8'),
          meta: {
            label: '银行工作人员',
            permissions: ['PM020801']
          }
        },
        {
          id: '16',
          path: '/userInfoList2',
          name: 'userInfoList2',
          hidden: false,
          icon: '',
          component: () => import('@/views/userInfo/UserInfoList2'),
          meta: {
            label: '管理员',
            permissions: ['PM020601']
          }
        },
        {
          id: '17',
          path: '/userInfoList1',
          name: 'userInfoList1',
          hidden: false,
          icon: '',
          component: () => import('@/views/userInfo/UserInfoList1'),
          meta: {
            label: '超级管理员',
            permissions: ['PM020701']
          }
        }
      ]
    },
    {
      id: '2',
      path: '/townInfo',
      name: 'townInfoList',
      hidden: false,
      icon: 'el-icon-office-building',
      component: () => import('@/views/townInfo/TownInfoList'),
      meta: {
        label: '乡镇信息',
        permissions: ['PM030101']
      }
    },
    {
      id: '3',
      path: '/varietyInfo',
      name: 'varietyInfoList',
      hidden: false,
      icon: 'el-icon-tickets',
      component: () => import('@/views/varietyInfo/VarietyInfoList'),
      meta: {
        label: '种植品种',
        permissions: ['PM040101']
      }
    },
    {
      id: '4',
      path: '/carousel',
      name: 'carouselList',
      hidden: false,
      icon: 'el-icon-picture-outline',
      component: () => import('@/views/carousel/CarouselList'),
      meta: {
        label: '首页轮播',
        permissions: ['PM050101']
      }
    },
    {
      id: '5',
      path: '/',
      name: 'digitalPlanting',
      hidden: false,
      icon: 'el-icon-notebook-1',
      meta: {
        label: '数字种植',
        permissions: ['PM060101', 'PM060201']
      },
      children: [
        {
          id: '51',
          path: '/digitalPlantingType',
          name: 'digitalPlantingType',
          hidden: false,
          icon: '',
          component: () => import('@/views/digitalPlantingType/DigitalPlantingTypeList'),
          meta: {
            label: '类型管理',
            permissions: ['PM060101']
          }
        },
        {
          id: '52',
          path: '/digitalPlantingManual',
          name: 'digitalPlantingManual',
          hidden: false,
          icon: '',
          component: () => import('@/views/digitalPlantingManual/DigitalPlantingManualList'),
          meta: {
            label: '内容管理',
            permissions: ['PM060201']
          }
        }
      ]
    },
    {
      id: '6',
      path: '/',
      name: 'shuZiJiaGong',
      hidden: false,
      icon: 'el-icon-truck',
      meta: {
        label: '数字加工',
        permissions: ['PM070101', 'PM070201']
      },
      children: [
        {
          id: '61',
          path: '/priceRelease',
          name: 'priceRelease',
          hidden: false,
          icon: '',
          component: () => import('@/views/priceRelease/PriceReleaseList'),
          meta: {
            label: '价格发布',
            permissions: ['PM070101']
          }
        },
        {
          id: '62',
          path: '/industrialEntity',
          name: 'industrialEntity',
          hidden: false,
          icon: '',
          component: () => import('@/views/industrialEntity/IndustrialEntityList'),
          meta: {
            label: '合作社',
            permissions: ['PM070201']
          }
        }
      ]
    },
    {
      id: '7',
      path: '/onlineConsultation',
      name: 'onlineConsultation',
      hidden: false,
      icon: 'el-icon-help',
      component: () => import('@/views/onlineConsultation/OnlineConsultationList'),
      meta: {
        label: '椒友在线',
        permissions: ['PM080101']
      }
    },
    {
      id: '8',
      path: '/',
      name: 'demand',
      hidden: false,
      icon: 'el-icon-chat-line-square',
      meta: {
        label: '需求大厅',
        permissions: ['PM090101', 'PM090201']
      },
      children: [
        {
          id: '81',
          path: '/demandSupply',
          name: 'demandSupply',
          hidden: false,
          icon: '',
          component: () => import('@/views/demandSupply/DemandSupplyList'),
          meta: {
            label: '社会化服务',
            permissions: ['PM090101']
          }
        },
        {
          id: '82',
          path: '/demandWork',
          name: 'demandWork',
          hidden: false,
          icon: '',
          component: () => import('@/views/demandWork/DemandWorkList'),
          meta: {
            label: '用工需求',
            permissions: ['PM090201']
          }
        }
      ]
    },
    {
      id: '9',
      path: '/financialProducts',
      name: 'financialProducts',
      hidden: false,
      icon: 'el-icon-medal',
      component: () => import('@/views/financialProducts/FinancialProductsList'),
      meta: {
        label: '金融产品',
        permissions: ['PM100101']
      }
    },
    {
      id: '10',
      path: '/associationForum',
      name: 'associationForum',
      hidden: false,
      icon: 'el-icon-chat-dot-square',
      component: () => import('@/views/associationForum/AssociationForumList'),
      meta: {
        label: '协会之家',
        permissions: ['PM110101']
      }
    },
    {
      id: '11',
      path: '/',
      name: 'marketing',
      hidden: false,
      icon: 'el-icon-data-line',
      meta: {
        label: '数字营销',
        permissions: ['PM120101', 'PM120201']
      },
      children: [
        {
          id: '111',
          path: '/supplyMarketingConsulting',
          name: 'supplyMarketingConsulting',
          hidden: false,
          icon: '',
          component: () => import('@/views/supplyMarketingConsulting/SupplyMarketingConsultingList'),
          meta: {
            label: '供销咨询',
            permissions: ['PM120101']
          }
        },
        {
          id: '112',
          path: '/trends',
          name: 'trends',
          hidden: false,
          icon: '',
          component: () => import('@/views/trends/TrendsList'),
          meta: {
            label: '进出口数据',
            permissions: ['PM120201']
          }
        }
      ]
    },
    {
      id: '900',
      path: '/',
      name: 'sys',
      hidden: false,
      icon: 'el-icon-setting',
      meta: {
        label: '系统管理',
        permissions: ['PM010101', 'PM010201', 'PM010301', 'PM010401']
      },
      children: [
        {
          id: '910',
          path: '/sysRoleList',
          name: 'sysRoleList',
          hidden: false,
          icon: '',
          component: () => import('@/views/sysRole/SysRoleList'),
          meta: {
            label: '权限组信息',
            permissions: ['PM010101']
          }
        },
        {
          id: '920',
          path: '/sysUserList',
          name: 'sysUserList',
          hidden: false,
          icon: '',
          component: () => import('@/views/sysUser/SysUserList'),
          meta: {
            label: '用户信息',
            permissions: ['PM010201']
          }
        },
        {
          id: '930',
          path: '/auditLogList',
          name: 'auditLogList',
          hidden: false,
          icon: '',
          component: () => import('@/views/sysAuditLog/AuditLogList'),
          meta: {
            label: '审计日志',
            permissions: ['PM010301']
          }
        },
        {
          id: '940',
          path: '/sysConfigList',
          name: 'sysConfigList',
          hidden: false,
          icon: '',
          component: () => import('@/views/sysConfig/SysConfigList'),
          meta: {
            label: '参数配置',
            permissions: ['PM010401']
          }
        }
      ]
    }
  ]
}

const createRouter = () => new VueRouter({
  mode: 'history',
  routes: fixedRoutes
})

const router = createRouter()

// 写一个重置路由的方法，切换用户后，或者退出时清除动态加载的路由
export function resetRouter () {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // 新路由实例matcer，赋值给旧路由实例的matcher，（相当于replaceRouter）
}

// 路由守卫
router.beforeEach((to, from, next) => {
  if (to.path === '/login') {
    // if (to.path === '/ocrDemo') {
    next()
  } else {
    const token = getToken()
    if (!token) {
      next('/login')
      // next('/ocrDemo')
    } else {
      next()
      // 如果路由没有根据登录用户的权限进行筛选，就筛选一次
      if (!store.state.addRouterFlag) {
        store.commit('SET_ADDROUTERFLAG', true)
        // 根据登录用户拥有的权限筛选路由
        const userInfo = getUser()
        if (userInfo && userInfo.urlSet) {
          const userPermissions = userInfo.urlSet
          const permissionRoutes = createPermissionRoutes() // 新创建一份，解决变量定义老改变原始问题
          const rightRouters = filterRouters(permissionRoutes, userPermissions)
          // 筛选后的路由添加注册
          const indexRoutes = createIndexRoute() // 新创建一份，解决变量定义老改变原始问题
          const menu = indexRoutes.children.concat(rightRouters)
          let indexChildren = indexRoutes.children
          for (const r of rightRouters) {
            if (r.children && r.children.length > 0) {
              indexChildren = indexChildren.concat(r.children)
            } else {
              indexChildren = indexChildren.concat(r)
            }
          }
          const indexRoute = createIndexRoute() // 新创建一份，解决变量定义老改变原始问题
          indexRoute.children = indexChildren
          resetRouter()
          router.addRoute(indexRoute)
          router.addRoute({
            path: '*',
            redirect: '/notFound',
            hidden: true
          })
          // 除了要动态创建路由之外，还要根据获取到的这个权限列表动态菜单，所以存在 store 中，方便不同的组件获取
          store.commit('SET_ROUTES', menu)
          // push之后，会重新进入beforeEach的钩子里，直接进入第一个判断
          router.push({ path: to.path })
        }
      }
    }
  }
})

// 根据路由里的meta.permissions与用户拥有权限进行对比筛选，递归
function filterRouters (permissionRoutes, userPermissions) {
  const rightRouters = permissionRoutes.filter((router) => {
    if (havePermission(router, userPermissions)) {
      if (router.children && router.children.length > 0) {
        router.children = filterRouters(router.children, userPermissions)
      }
      return true
    } else {
      return false
    }
  })
  return rightRouters
}

// 检测用户权限里面在路由权限里面是否包含
function havePermission (router, userPermissions) {
  if (router.meta && router.meta.permissions) {
    return userPermissions.some(role => router.meta.permissions.indexOf(role) != -1)
  } else {
    return true
  }
}

export default router
